/**
 * Person attributes and the "Whose steps?" clue line (DECISIONS 2026-10-03): after a wrong guess, one line compares
 * the guess with the answer — century of their main activity (same / answer later / answer earlier), field (main
 * theme tag) and where they're from (continent). An attribute either name lacks shows as "—".
 */
import type { Continent, NameAttrs, Theme } from "../puzzles/types";

export interface ClueLine {
  century: "same" | "later" | "earlier" | null;
  /** The guess's field, and whether the answer shares it. */
  field: { same: boolean; field: Theme } | null;
  /** The guess's continent, and whether the answer shares it. */
  from: { same: boolean; from: Continent } | null;
}

/** Compare a wrong guess with the answer; null when neither has any attribute to compare. */
export function compareNames(guess: NameAttrs | undefined, answer: NameAttrs | undefined): ClueLine | null {
  if (!guess || !answer) return null;
  const century = guess.century != null && answer.century != null ? (answer.century === guess.century ? "same" : answer.century > guess.century ? "later" : "earlier") : null;
  const field = guess.field && answer.field ? { same: guess.field === answer.field, field: guess.field } : null;
  const from = guess.from && answer.from ? { same: guess.from === answer.from, from: guess.from } : null;
  return century || field || from ? { century, field, from } : null;
}

let cache: Promise<Record<string, NameAttrs>> | null = null;
/** The attribute table, loaded once as its own chunk (not part of the first load). Empty if it can't load. */
export const loadAttrs = (): Promise<Record<string, NameAttrs>> =>
  (cache ??= import("virtual:name-attrs").then(
    (m) => m.attrs,
    () => ({}),
  ));
